"use strict";

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defaultConfig = _interopRequireDefault(require("../../defaultConfig"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = {
  dark: 'media',
  variants: {
    backgroundColor: [].concat(_toConsumableArray(_defaultConfig.default.variants.backgroundColor), ['dark']),
    gradientColorStops: [].concat(_toConsumableArray(_defaultConfig.default.variants.gradientColorStops), ['dark']),
    borderColor: [].concat(_toConsumableArray(_defaultConfig.default.variants.borderColor), ['dark']),
    divideColor: [].concat(_toConsumableArray(_defaultConfig.default.variants.divideColor), ['dark']),
    placeholderColor: [].concat(_toConsumableArray(_defaultConfig.default.variants.placeholderColor), ['dark']),
    textColor: [].concat(_toConsumableArray(_defaultConfig.default.variants.textColor), ['dark'])
  }
};
exports.default = _default;